import React from 'react';
import {AsyncSelect} from '@atlaskit/select';
import {confluenceService} from "../../api/ConfluenceService";
import {useFlags} from "@atlaskit/flag";
import {errorFlag} from "../../model/flags";
import {Label} from "@atlaskit/form";

export interface GroupOption {
    value: string;
    label: string;
}

interface GroupSelectProps {
    selectedGroups: Array<GroupOption>;
    onChange: (groups: any) => void;
    label?: string;
    isLoading: boolean;
}

export const AsyncGroupSelect = (props: GroupSelectProps) => {
    const {showFlag} = useFlags();

    const handleOperationError = (error?: string) => {
        const errMsg = error ?? "There was an error. Please try again later or contact support.";
        showFlag(errorFlag({title: "Error!", description: errMsg}));
    }

    const searchGroups = async (inputValue: string) => {
        try {
            return await confluenceService.getGroupsByQuery(inputValue).then(groups => groups.map(group => ({value: group.id, label: group.name})));
        } catch (e) {
            handleOperationError("There was an error while searching for groups. Please try again later or contact support.");
        }
    }

    const promiseOptions = (inputValue: string) => searchGroups(inputValue);

    return (
        <div className={"group-select"}>
            <Label htmlFor="group-select-input">{props.label ? props.label : "Type to search for groups"}</Label>
            <AsyncSelect
                inputId="group-select-input"
                isMulti
                value={props.selectedGroups}
                placeholder="Select group(s)"
                defaultOptions
                isLoading={props.isLoading}
                loadOptions={promiseOptions}
                onChange={(groups) => props.onChange(groups)}
            />
        </div>);
};
